'use strict';

// Packages
import 'jquery';
import '@popperjs/core';
import 'bootstrap';
import 'slick-slider';

import Slider from './components/slider';
import FontSizer from './components/font-sizer';
import Utilities from './components/utilities';
import Parallax from './components/parallax';

$(function() {
  new Slider();
  new FontSizer();
  new Utilities();
  new Parallax();
});